/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Otp_Purpose_Change_EmailInputs */

const th_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันอีเมลใหม่ของคุณ`)
};

const en_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`confirm your new email address`)
};

const ja_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいメールアドレスを確認する`)
};

const zh_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认你的新邮箱地址`)
};

const es_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`confirmar tu nueva dirección de correo`)
};

const pt_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`confirmar seu novo endereço de e-mail`)
};

const id_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mengonfirmasi alamat email baru Anda`)
};

const fr_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`confirmer votre nouvelle adresse e-mail`)
};

const tl_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kumpirmahin ang bago mong email address`)
};

const vi_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`xác nhận địa chỉ email mới của bạn`)
};

const ko_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 이메일 주소를 확인할`)
};

const de_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deine neue E-Mail-Adresse bestätigen`)
};

const ru_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`подтвердить ваш новый адрес почты`)
};

const tr_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yeni e-posta adresinizi onaylamak`)
};

const it_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`confermare il tuo nuovo indirizzo email`)
};

const pl_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`potwierdzić nowy adres e-mail`)
};

const uk_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`підтвердити вашу нову адресу пошти`)
};

const hi_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना नया ईमेल पता पुष्ट करने`)
};

const ar_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تؤكّد بريدك الإلكتروني الجديد`)
};

const ms_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mengesahkan alamat e-mel baharu anda`)
};

const bn_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার নতুন ইমেল ঠিকানা নিশ্চিত করার`)
};

const zh_tw2_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認你的新電子郵件位址`)
};

const zh_hk2_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認你的新電子郵件位址`)
};

const ur_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اپنا نیا ای میل پتہ تصدیق کرنے`)
};

const fa_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأیید نشانی ایمیل تازه‌تان`)
};

const sw_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kuthibitisha anwani yako mpya ya barua pepe`)
};

const nl_email_otp_purpose_change_email = /** @type {(inputs: Email_Otp_Purpose_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`je nieuwe e-mailadres te bevestigen`)
};

/**
* | output |
* | --- |
* | "confirm your new email address" |
*
* @param {Email_Otp_Purpose_Change_EmailInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_otp_purpose_change_email = /** @type {((inputs?: Email_Otp_Purpose_Change_EmailInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Otp_Purpose_Change_EmailInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_otp_purpose_change_email(inputs)
	if (locale === "ja") return ja_email_otp_purpose_change_email(inputs)
	if (locale === "zh") return zh_email_otp_purpose_change_email(inputs)
	if (locale === "es") return es_email_otp_purpose_change_email(inputs)
	if (locale === "pt") return pt_email_otp_purpose_change_email(inputs)
	if (locale === "id") return id_email_otp_purpose_change_email(inputs)
	if (locale === "fr") return fr_email_otp_purpose_change_email(inputs)
	if (locale === "tl") return tl_email_otp_purpose_change_email(inputs)
	if (locale === "vi") return vi_email_otp_purpose_change_email(inputs)
	if (locale === "ko") return ko_email_otp_purpose_change_email(inputs)
	if (locale === "de") return de_email_otp_purpose_change_email(inputs)
	if (locale === "ru") return ru_email_otp_purpose_change_email(inputs)
	if (locale === "tr") return tr_email_otp_purpose_change_email(inputs)
	if (locale === "it") return it_email_otp_purpose_change_email(inputs)
	if (locale === "pl") return pl_email_otp_purpose_change_email(inputs)
	if (locale === "uk") return uk_email_otp_purpose_change_email(inputs)
	if (locale === "hi") return hi_email_otp_purpose_change_email(inputs)
	if (locale === "ar") return ar_email_otp_purpose_change_email(inputs)
	if (locale === "ms") return ms_email_otp_purpose_change_email(inputs)
	if (locale === "bn") return bn_email_otp_purpose_change_email(inputs)
	if (locale === "zh-TW") return zh_tw2_email_otp_purpose_change_email(inputs)
	if (locale === "zh-HK") return zh_hk2_email_otp_purpose_change_email(inputs)
	if (locale === "ur") return ur_email_otp_purpose_change_email(inputs)
	if (locale === "fa") return fa_email_otp_purpose_change_email(inputs)
	if (locale === "sw") return sw_email_otp_purpose_change_email(inputs)
	if (locale === "nl") return nl_email_otp_purpose_change_email(inputs)
	return en_email_otp_purpose_change_email(inputs)
});